import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';


export interface MobileAppTopBarStyleProps {
  safeViewTopHeight: number,
  backgroundColor?: string;
  zIndex: number;
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: 'auto',
    height: ({ safeViewTopHeight }: MobileAppTopBarStyleProps) => safeViewTopHeight,
    backgroundColor: ({ backgroundColor }) => backgroundColor ?? theme.color.greys[10],
    zIndex: ({ zIndex }) => zIndex ?? 9001,
  },
}), { name: 'MobileAppTopBar', index: StylesIndexInjections.UI_ATOMS });
